import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ExportStatus } from 'api/export/types';
import { Action, ObjectType } from 'api/pushes';
import { toastService } from 'components/molecules/toast';
import { useUserWsUpdates } from 'hooks/use-user-ws-updates';
import { useTranslate } from 'hooks/use-translation';
import { logger } from 'services';
import { consumeEmailExportPending, isExportAlreadyHandled, markExportHandled } from './use-async-export';
// App-shell fallback listener. Handles Pusher export events when the user has
// navigated away from the page that triggered the export (per-page listener
// unmounted). Defers one tick via setTimeout so the per-page handler can mark
// an export handled first for normal (non-email) flows.
export const GlobalAsyncExportListener = ()=>{
    const translate = useTranslate();
    const handleExport = useCallback((response)=>{
        logger.log('GlobalAsyncExportListener ~ socketData', response);
        let data;
        try {
            data = JSON.parse(response.data);
        } catch (unused) {
            return;
        }
        // Consume synchronously regardless of export outcome — a Failed/Processing
        // event must still clear the flag so the next export gets the right copy.
        const isEmailExport = consumeEmailExportPending();
        if (!(data === null || data === void 0 ? void 0 : data.downloadUrl) || data.status !== ExportStatus.Completed) {
            return;
        }
        const { exportsMetaDataId, downloadUrl } = data;
        setTimeout(()=>{
            // Yield to per-page listener for non-email exports it already handled.
            if (!isEmailExport && exportsMetaDataId && isExportAlreadyHandled(exportsMetaDataId)) {
                return;
            }
            if (exportsMetaDataId) {
                markExportHandled(exportsMetaDataId);
            }
            toastService({
                title: translate('async.exports.success.title'),
                message: /*#__PURE__*/ _jsxs("p", {
                    children: [
                        translate(isEmailExport ? 'async.exports.success.email.message' : 'async.exports.success.message'),
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("a", {
                            href: downloadUrl,
                            download: true,
                            children: translate('download.file')
                        })
                    ]
                }),
                duration: 0
            }).success();
        }, 0);
    }, [
        translate
    ]);
    useUserWsUpdates(handleExport, [
        Action.Create,
        ObjectType.AsyncProcessor
    ]);
    return null;
};
